<template>
  <div class="list-view">
    <b-overlay
      :show="loading"
      rounded="sm"
      spinner-variant="success"
      spinner-type="grow"
    >
      <div class="list-wrapper pb-2">
        <div v-if="tasks && tasks.length > 0">
          <div
            class="list-item my-2 d-flex border rounded cursor-pointer custom-hover p-3"
            v-for="(item, index) in tasks"
            :key="'listViewItem' + index"
            @click="redirectToDetailView(item.id)"
            style="min-height: 103px;"
          >
            <div class="list-label flex-fill px-2">
<!--              {{ item }}-->
              <b-row>
                <b-col xs="6" md="8">{{ item.title }}</b-col>
                <b-col xs="6" md="4" class="text-muted small text-right">
                  <span class="text-nowrap">
                  {{ item.statusReadableName }}
                  <BIcon icon="circle-fill" class="mr-2" :class="statusIconSwitch(item.status)" />
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-muted small">
                  {{ formatRelativeDate(item.createdOn) }}
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <div v-else-if="tasks" class="max-content-width mx-auto mb-2">
          <div class="max-content-width mx-auto mb-2">
            <i class="fas fa-tasks" style="font-size: 2em; color: #807F8F;"></i>
          </div>
          <div class="max-content-width mx-auto">
            Készen vagy!
          </div>
        </div>

        <div v-else class="max-content-width mx-auto mb-2">
          <div class="max-content-width mx-auto mb-2">
            <i class="fas fa-tasks" style="font-size: 2em; color: #807F8F;"></i>
          </div>
          <div class="max-content-width mx-auto">
            Értesítők betöltése...
          </div>
        </div>
      </div>

      <!--
      <div
        v-if="enablePagination && listData && listData.length > 0"
        class="pagination-wrapper"
      >

      </div>
      -->
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import 'moment/locale/hu';

export default {
  name: "TaskView",

  props: {
    tasks: {
      type: Array
    },
    apiLoading: {
      type: Boolean,
      default: true
    },
    detailView: {
      type: String,
    },
    displayProp: {
      type: String,
      default: "content",
    },
    backRouterLink: {
      type: String,
      default: null,
    },
    displayAll: {
      type: Boolean,
      default: false,
    },
    parentCurrentPage: {
      type: Number,
      default: null,
    },
    parentItemsPerPage: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentPage: 0,
      rowsNumber: 1,
      perPage: 3,
      loading: false,
    };
  },
  methods: {
    formatRelativeDate(timestamp){
      const date = moment(timestamp);
      if (moment().diff(date, 'days') > 2) {
        return date.format('YYYY.MM.DD.');
      } else {
        return date.fromNow();
      }
    },

    getUrlData() {
      if (this.$route.query.pageNumber) {
        this.currentPage = this.$route.query.pageNumber;
        this.perPage = this.$route.query.perPage;
      }
    },

    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    redirectToDetailView(id) {
      let self = this;
      if (self.detailView) {
        if (self.backRouterLink) {
          // Use props if available, otherwise fall back to component data or route query
          const pageNumber = self.parentCurrentPage !== null ? self.parentCurrentPage - 1 : (self.$route.query.pageNumber ? parseInt(self.$route.query.pageNumber) : self.currentPage);
          const perPage = self.parentItemsPerPage !== null ? self.parentItemsPerPage : (self.$route.query.perPage ? parseInt(self.$route.query.perPage) : self.perPage);
          
          self.$router.push({
            path: self.detailView,
            query: {
              id: id,
              backRouterLink: self.backRouterLink.toString(),
              pageNumber: pageNumber,
              perPage: perPage,
            },
          });
        } else {
          self.$router.push(self.detailView + "/" + id);
        }
      }
    },

    classSwitch(statusId) {
      switch (statusId) {
        case 900:
          return "read";
        case 902:
          return "unread";
        case 904:
          return "done";
      }
    },
    statusIconSwitch(statusId) {
      switch (statusId) {
        case 'READ':
          return "text-warning";
        case 'UNREAD':
          return "text-danger";
        case 'DONE':
          return "text-success";
      }
    },
    resetRouter() {
      if (this.$route.query.time) {
        this.$router.push("/app/home");
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    if (this.resetRouter()) {
      this.perPage = this.itemPerPage ? this.itemPerPage : 3;
      this.getUrlData();
    }
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  watch: {
    apiLoading: function(newVal) {
      this.loading = newVal
    }
  },
};
</script>

<style scoped>
.max-content-width {
  width: max-content;
}

.empty-list-image {
  width: 75px;
}

.list-icon {
  width: 25px;
  text-align: center;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.list-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.list-button-wrapper {
  width: 100px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.list-button {
  text-align: center;
  border: none;
  border-radius: 5px;
  cursor: default;
}

.list-button.read {
  background-color: #ffe2e5;
  color: #f64e60;
}

.list-button.unread {
  background-color: #fff4de;
  color: #ffa800;
}

.list-button.done {
  background-color: lightgreen;
  color: green;
}

.list-button.filed {
  background-color: #fff4de;
  color: #ffa800;
}

.list-button.jam {
  background-color: #ffe2e5;
  color: #f64e60;
}

</style>
